export default __webpack_public_path__ + "static/media/nouser2.724b79cd.png";